import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function briefsReducer(state = initialState.briefs, action){
    let briefsObject = {};
    console.log('briefsReducer', action);
    switch(action.type){
      case types.BRIEFS_SUCCESS:
        return Object.assign({}, state, {
          isLoading: false,
          briefs: action.briefs
        });
      case types.SET_BRIEFS_LOADING:
        return Object.assign({}, state, {
          isLoading: action.isLoading
        });
      case types.SET_ACTIVE_BRIEF:
        return Object.assign({}, state, {
          activeBrief: action.activeBrief
        });
      default:
        return state;
    }
}
